export * from './mamba';
export * from './prototype';
import { EnumStatusCode } from '@mamba/clients';
import { Context } from '@nuxt/types';
import lodash from 'lodash';
import { $AppConfig } from './global';
import { WechatReady } from './initialize/miniprogram';
import { PagesEnum } from './pages';
import { Store } from './store';
export default async (ctx: Context) => {
  WechatReady(ctx);
  setContext(ctx);
};

/**
 * 写入常量配置
 * @param {Context} ctx
 */
function setContext(ctx: Context) {
  lodash.set(ctx, '$Store', Store);
  lodash.set(ctx, 'AppConfig', $AppConfig);
  lodash.set(ctx, '$Pages', PagesEnum);
  lodash.set(ctx, '$StatusCode', EnumStatusCode);
}
declare global {
  interface Window {
    tezignExternalTrack: {
      init: (initParams: any) => {};
      track: (trackParams: any) => {};
    };
  }
}
